import type { GameResponse } from '@warcarp/api-types'
import { currentPlayer } from './turnHelpers'

export function homeGameGroups(games: GameResponse[], completed: boolean, userId?: string) {
  if (completed) return [{ title: 'Completed campaigns', data: games }]
  const turns: GameResponse[] = [], invites: GameResponse[] = [], waiting: GameResponse[] = []
  for (const game of games) {
    const eliminated = (game.state?.eliminated ?? []) as string[]
    if (game.viewerInvitationStatus === 'pending') invites.push(game)
    else if (userId && game.status === 'ACTIVE' && currentPlayer(game, eliminated)?.userId === userId) turns.push(game)
    else waiting.push(game)
  }
  return [{ title: 'Your turn', data: turns }, { title: 'Invitations', data: invites },
    { title: 'Waiting for others', data: waiting }].filter(section => section.data.length)
}
